import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { canViewReports, checkHOD, checkHOU, hideMultipleMenu } from '../../permission-utils/settings';

const PharmacyMenu = () => {
	const staff = useSelector(state => state.user.profile);
	const [isSupervisor, setIsSuperVisor] = useState(false);

	useEffect(() => {
		const fetchData = async () => {
			const isHOD = await checkHOD();
			const isHOU = await checkHOU();

			if (isHOD || isHOU) {
				setIsSuperVisor(true);
			}
		};

		fetchData();
	}, []);

	const isPharmacy = ['pharmacy', 'pharmacy-supervisor'].includes(staff?.role?.slug);

	return (
		<>
			{isPharmacy && (
				<li className="sub-header">
					<span>DISPENSING</span>
				</li>
			)}
			{(isSupervisor || canViewReports(staff, 'inventory-audit')) && (
				<li>
					<Link to="/pharmacy/overview">
						<div className="icon-w">
							<div className="os-icon os-icon-layers" />
						</div>
						<span>Overview</span>
					</Link>
				</li>
			)}
			<li>
				<Link to="/pharmacy">
					<div className="icon-w">
						<div className="os-icon os-icon-layers" />
					</div>
					<span>Dashboard</span>
				</Link>
			</li>
			<li>
				<Link to="/pharmacy/discharge-queue">
					<div className="icon-w">
						<div className="icon-feather-log-out" />
					</div>
					<span>Discharge Queue</span>
				</Link>
			</li>
			{!['inventory-audit', 'internal-control-audit', 'pharmacy', 'pharmacy-supervisor'].includes(staff.role.slug) && (
				<li>
					<Link to="/pharmacy/new-request">
						<div className="icon-w">
							<div className="os-icon os-icon-plus-circle" />
						</div>
						<span>New Request</span>
					</Link>
				</li>
			)}
			{/* <li>
				<Link to="/pharmacy/immunization">
					<div className="icon-w">
						<div className="os-icon os-icon-layers" />
					</div>
					<span>Immunization</span>
				</Link>
			</li> */}

			{isPharmacy && (
				<li className="sub-header">
					<span>BILLING</span>
				</li>
			)}
			<li>
				<Link to="/pharmacy/billing">
					<div className="icon-w">
						<div className="os-icon os-icon-layers" />
					</div>
					<span>Pay Point</span>
				</Link>
			</li>
			<li>
				<Link to="/pharmacy/billing/hmo">
					<div className="icon-w">
						<div className="os-icon os-icon-layers" />
					</div>
					<span>HMO Transactions</span>
				</Link>
			</li>
			<li>
				<Link to="/hmo/schemes">
					<div className="icon-w">
						<div className="os-icon os-icon-layers" />
					</div>
					<span>HMO Schemes</span>
				</Link>
			</li>

			{isPharmacy && (
				<li className="sub-header">
					<span>INVENTORY</span>
				</li>
			)}
			<li>
				<Link to="/pharmacy/inventory">
					<div className="icon-w">
						<div className="os-icon os-icon-layers" />
					</div>
					<span>Inventory</span>
				</Link>
			</li>
			<li>
				<Link to="/pharmacy/vendors">
					<div className="icon-w">
						<div className="os-icon os-icon-layers" />
					</div>
					<span>Vendors</span>
				</Link>
			</li>
			{isSupervisor && (
				<li>
					<Link to="/pharmacy/category">
						<div className="icon-w">
							<div className="os-icon os-icon-layers" />
						</div>
						<span>Categories</span>
					</Link>
				</li>
			)}
			<li>
				<Link to="/report/pharmacy">
					<div className="icon-w">
						<div className="os-icon os-icon-layers" />
					</div>
					<span>Reports</span>
				</Link>
			</li>
			{isSupervisor && hideMultipleMenu(staff) && (
				<li>
					<Link to="/hmo/schemes">
						<div className="icon-w">
							<div className="os-icon os-icon-layers" />
						</div>
						<span>HMO Schemes</span>
					</Link>
				</li>
			)}
			{isSupervisor && hideMultipleMenu(staff) && (
				<>
					<li className="sub-header">
						<span>LABS</span>
					</li>
					<li>
						<Link to="/lab">
							<div className="icon-w">
								<div className="os-icon os-icon-layers" />
							</div>
							<span>Lab</span>
						</Link>
					</li>
				</>
			)}
		</>
	);
};

export default PharmacyMenu;
